import type { ConfirmDialogProps } from '@/components/ui/ConfirmDialog'

/**
 * Product confirmation dialogs — sectioned grey-blue header/footer (image 2),
 * Save Changes shell with centered copy and equal-width Yes/No-style actions.
 * Validation errors use {@link showProductApiError}, not this chrome.
 */
export const productConfirmPresentation = {
  presentation: 'saveChanges',
  primaryFirst: true,
  actionStyle: 'application',
  sectionedChrome: true,
  equalWidthActions: true,
  messageAlign: 'center',
  messageWeight: 'normal',
} as const satisfies Partial<ConfirmDialogProps>
